module.exports = __webpack_public_path__ + "static/media/1007360.8e57e98d.jpg";